"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.adminLevelAppPermissions = exports.ScopeLevelArr = exports.SCOPE_LEVEL_ADMIN = exports.SCOPE_LEVEL_SUPER = exports.TE_SOAP_SCOPE = exports.TE_SERVER_THREAD_SCOPE = exports.TE_ROOT_USER = exports.SERVICE_ACCOUNT = void 0;
const permission_enum_1 = require("../enums/permission.enum");
exports.SERVICE_ACCOUNT = 'SERVICE_ACCOUNT'; // M2M SCOPE FOR SUPER ACCESS ACROSS ORGANIZATIONS
exports.TE_ROOT_USER = 'TE_ROOT_USER'; // USER SCOPE FOR SUPER ACCESS ACROSS ORGANIZATIONS
exports.TE_SERVER_THREAD_SCOPE = 'TE_SERVER_THREAD::user'; // The scope permission needed for TE Viewer, TE Core default users
exports.TE_SOAP_SCOPE = 'TE_SOAP::user';
exports.SCOPE_LEVEL_SUPER = permission_enum_1.EScopeLevel.SUPER;
exports.SCOPE_LEVEL_ADMIN = permission_enum_1.EScopeLevel.ADMIN;
exports.ScopeLevelArr = [permission_enum_1.EScopeLevel.ADMIN, permission_enum_1.EScopeLevel.SUPER];
exports.adminLevelAppPermissions = [
    'TE_ADMIN::manageUsers',
    'TE_ADMIN::viewCullingReport',
    'TE_CORE::activityManager',
    'TE_ADMIN::manageTimeRules',
    'TE_CORE::noTimeRules',
    'TE_CORE::setOrganizationsOnReservations',
    'TE_CORE::managePeriods',
    'TE_CORE::teExam',
    'TE_CORE::manageViews',
    'TE_RESERVE::noTimeRules',
    'TE_EXAM::supervisor',
    'TE_EXAM::supervisorCoordinator',
    'TE_EXAM::dec',
    'TE_EXAM::cea',
    'TE_EXAM_V3::invigilator',
];
